export const ISDARK = "ISDARK";

//=============== graph action ===============
export const UPDATE_NODES = "UPDATE_NODES";
export const UPDATE_WALL_NODES = "UPDATE_WALL_NODES";
export const UPDATE_START_NODES = "UPDATE_START_NODES";
export const UPDATE_END_NODES = "UPDATE_END_NODES";

//=============== mouse action ===============
export const SET_MOUSE_DOWN = "SET_MOUSE_DOWN";
export const SET_MOUSE_MOVE = "SET_MOUSE_MOVE";
export const ON_MOUSE_DOWN = "ON_MOUSE_DOWN";
export const ON_MOUSE_UP = "ON_MOUSE_UP";
export const SET_CLICK_POS = "SET_CLICK_POS";
export const SET_START_MOVE = "SET_START_MOVE";
export const SET_END_MOVE = "SET_END_MOVE";
export const SET_PATH_FINDING = "SET_PATH_FINDING";
export const SET_SPEED = "SET_SPEED";
//=============== control action =============
export const SET_PATH_ALGO = "SET_PATH_ALGO";
export const START_PATH_FINDING = "START_PATH_FINDING";
export const RESET_ALL = "RESET_ALL";
export const CLEAR_WALL = "CLEAR_WALL";

export const NEXTACTION = "NEXTACTION";
export const ISFINDING = "ISFINDING";
